import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static values = { addressId: String }

  connect() {
    this.initializeSelectPicker()
  }

  async submit(event) {
    event.preventDefault()
    event.stopPropagation()

    const form = this.element
    const fields = form.querySelectorAll('input, select, textarea')
    for (const field of fields) {
      if (!field.checkValidity()) {
        field.classList.add('is-invalid')
        field.reportValidity()
        return
      } else {
        field.classList.remove('is-invalid')
      }
    }

    const formData = new FormData(form)

    try {
      const response = await patch(form.action, {
        body: formData,
        responseKind: "turbo-stream"
      })

      if (response.ok) {
        this.updateDropdownLabel(formData)
        this.hideFormAndShowPreview()
      } else {
        await response.renderTurboStream()
      }
    } catch (error) {
      console.error("Form submission error:", error)
    }
  }

  updateDropdownLabel(formData) {
    const option = document.querySelector(`option[value="${this.addressIdValue}"]`)
    if (option) {
      const locationName = formData.get('address[location_name]')
      const addressLine1 = formData.get('address[address_line_1]')
      const city = formData.get('address[city]')
      const state = formData.get('address[state_province_region]')

      const baseLabel = locationName || addressLine1
      const prefix = option.text.match(/^\[.*?\]\s*/)?.[0] ?? ''

      if (prefix) {
        option.text = `${prefix}${baseLabel}`
      } else {
        option.text = `${baseLabel} - ${city}, ${state}`
      }
    }
  }

  hideFormAndShowPreview() {
    const editContainer = document.getElementById('edit_address_form_container')
    if (editContainer) editContainer.classList.add('d-none')

    const preview = document.getElementById(`preview-${this.addressIdValue}`)
    if (preview) preview.classList.remove('d-none')
  }

  initializeSelectPicker() {
    const selectElements = this.element.querySelectorAll('.selectpicker')
    if (selectElements.length > 0 && typeof $.fn.selectpicker === 'function') {
      $(selectElements).selectpicker('refresh')
    }
  }
}
